
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './BannerListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

interface BannerListingProps extends LayoutPropType {
  autoplay?: boolean;
}

export const BannerListing = ({
  data,
  autoplay = false,
  index,
}: BannerListingProps) => {
  //const
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title, {
        position: index,
      });
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) => {
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.title
        );
      }}
      style={{
        background: `${data?.backgroundColor}`,
      }}
    >
      <Swiper
        effect="creative"
        creativeEffect={{
          prev: {
            translate: ['-100%', 0, 0],
            scale: 0.9,
          },
          next: {
            translate: ['100%', 0, 0],
            scale: 0.9,
          },
        }}
        swiperModules={['Pagination']}
        spaceBetween={12}
        slidesPerView={1.3}
        centeredSlides={true}
        initialSlide={1}
        loop={true}
        speed={500}
        autoplay={
          autoplay
            ? {
                delay: 2500,
                disableOnInteraction: false,
              }
            : {}
        }
        slides={data?.data?.map((item, index) => (
          <div
            key={`${item?.coverImage}_${index}`}
            className={s.item}
            data-index={index}
            id={CARDID}
            aria-hidden
          >
            <AnimatedImage
              src={item?.coverImage}
              loading="eager"
              alt="coverImage"
            />
          </div>
        ))}
      />
    </div>
  );
};
